import React from 'react';
import './toast.css';
import { toast } from 'react-toastify';

export function showErrorToast(message: string, darkMode: boolean) {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: false,
    theme: darkMode ? 'dark' : 'light',
  });
}
